<template>
  <div class="personal-info"
       id="personalInfo">
    <p class="desc">个人信息</p>
    <el-form :model="personalInfo"
             :rules="personalInfoRules"
             ref="personalInfo">
      <el-form-item label="公司名称："
                    prop="company">
        <el-input class="gray"
                  :disabled="personalInfo.cusModifyCompanyName == 1?false:true"
                  v-model="personalInfo.company"></el-input>
      </el-form-item>
      <el-form-item label="联系人："
                    prop="contact">
        <el-input class="gray"
                  v-model="personalInfo.contact"></el-input>
      </el-form-item>
      <el-form-item label="登录账号："
                    prop="user">
        <el-input class="gray"
                  v-model="personalInfo.user"
                  :disabled="true"></el-input>
        <span class="update-btn"
              @click="toUpdatePass">修改密码</span>
      </el-form-item>
      <el-form-item label="手机号："
                    prop="mobile">
        <el-input class="gray"
                  v-model="personalInfo.mobile"
                  :disabled="true"></el-input>
        <span class="update-btn"
              @click="toUpdateMobile">更改手机</span>
      </el-form-item>
      <el-form-item label="所在区域："
                    prop="area">
        <el-cascader v-model="personalInfo.area"
                     :options="addressList"
                     :props="cascaderProps"></el-cascader>
      </el-form-item>
      <el-form-item label="详细地址："
                    prop="address">
        <el-input class="gray"
                  v-model="personalInfo.address"></el-input>
      </el-form-item>
      <el-form-item label="Email："
                    prop="email">
        <el-input class="gray"
                  v-model="personalInfo.email"></el-input>
      </el-form-item>
      <el-form-item label="QQ："
                    prop="qq">
        <el-input class="gray"
                  v-model="personalInfo.qq"></el-input>
      </el-form-item>
      <el-form-item class="btn-container">
        <el-button class="btn-red"
                   @click="savePersonalInfo">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script >
import XBUser from 'models/xb/user.js';
import DBAddress from 'models/db/address.js';
const xbUser = new XBUser();
const dbAddress = new DBAddress();
export default {
  data() {
    return {
      // 地址列表
      addressList: [],
      // Cascader 的 props 配置
      cascaderProps: {
        value: 'id',
        label: 'name'
      },
      personalInfo: {
        company: '',
        contact: '',
        user: '',
        mobile: '',
        area: [],
        address: '',
        email: '',
        qq: '',
        cusModifyCompanyName: null
      },
      personalInfoRules: {
        company: {
          required: true,
          message: '请填写公司名称',
          trigger: 'blur'
        },
        contact: {
          required: true,
          message: '请填写联系人',
          trigger: 'blur'
        },
        user: {
          required: true,
          message: '请填写登录账号',
          trigger: 'blur'
        },
        mobile: {
          required: true,
          message: '请填写手机号码',
          trigger: 'blur'
        },
        area: {
          required: true,
          message: '请填写所在区域',
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请填写详细地址',
          trigger: 'blur'
        }
      }
    };
  },
  methods: {
    savePersonalInfo() {
      this.$refs.personalInfo.validate(valid => {
        if (valid) {
          let data = {
            name: this.personalInfo.company,
            contact: this.personalInfo.contact,
            province: this.personalInfo.area[0],
            city: this.personalInfo.area[1],
            regions: this.personalInfo.area[2],
            address: this.personalInfo.address,
            email: this.personalInfo.email,
            qq: this.personalInfo.qq
          };
          this._updateXnInfo(data);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 去更改手机
    toUpdateMobile() {
      this.$router.push({
        path: '/personal/personal-menu/xb-update-mobile',
        query: {
          mobile: this.personalInfo.mobile
        }
      });
    },
    // 去更改密码
    toUpdatePass() {
      this.$router.push({
        path: '/personal/personal-menu/xb-update-password',
        query: {
          user: this.personalInfo.user
        }
      });
    },
    _getDBAddressMock() {
      dbAddress.getDBAddressMock().then(res => {
        console.log(res);
        this.addressList = res;
      });
    },
    _getXbInfo() {
      xbUser
        .getXbInfo()
        .then(res => {
          if (res.success) {
            this.personalInfo.company = res.result.name;
            this.personalInfo.contact = res.result.contact;
            this.personalInfo.user = res.result.username;
            this.personalInfo.mobile = res.result.telephone;
            this.personalInfo.cusModifyCompanyName = res.result.cusModifyCompanyName
            this.personalInfo.area = [];
            if (res.result.province) {
              this.personalInfo.area.push(res.result.province);
            }
            if (res.result.city) {
              this.personalInfo.area.push(res.result.city);
            }
            if (res.result.regions) {
              this.personalInfo.area.push(res.result.regions);
            }
            this.personalInfo.address = res.result.address;
            if (res.result.email) {
              this.personalInfo.email = res.result.email;
            }
            if (res.result.qq) {
              this.personalInfo.qq = res.result.qq;
            }
          } else {
            console.log('获取失败', res.result);
          }
        })
        .catch(e => {
          console.log('获取异常--', e);
        });
    },
    _updateXnInfo(data) {
      xbUser
        .updateXbInfo(data)
        .then(res => {
          if (res.success) {
            this.$message({
              message: '保存成功',
              center: true,
              type: 'success',
              duration: 1000
            });
          } else {
            this.$message({
              message: '保存失败，请重试',
              center: true,
              type: 'success',
              duration: 1000
            });
          }
        })
        .catch(e => {
          this.$message({
            message: '保存失败，请重试',
            center: true,
            type: 'success',
            duration: 1000
          });
        });
    }
  },
  created() {
    this._getDBAddressMock();
    this._getXbInfo();
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.personal-info {
  background: rgba(255, 255, 255, 1);
  border-radius: 2px;
  font-size: 16px;
  font-family: "PingFangSC-Regular";
  font-weight: 400;
  padding: 0 20px;
  padding-bottom: 92px;
  .update-btn {
    width: 100px;
    font-size: 12px;
    color: rgba(61, 116, 242, 1);
    cursor: pointer;
  }
  .desc {
    height: 40px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: rgba(96, 98, 102, 1);
    border-bottom: 1px solid #e4e4e4;
    margin-bottom: 20px;
  }
  .btn-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 100px;
    .btn-red {
      color: rgba(255, 255, 255, 1);
      width: 120px;
      height: 32px;
      background: rgba(223, 52, 69, 0.75);
      border-radius: 4px;
      padding: 0;
      &:hover {
        background: rgba(223, 52, 69, 1);
      }
      &:active {
        border: none;
      }
    }
  }
}
</style>

<style lang="scss">
#personalInfo {
  .el-form {
    .el-form-item {
      display: flex;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
      .el-form-item__label {
        width: 100px;
      }
      .el-form-item__content {
        display: flex;
        justify-content: flex-start;
        .el-input {
          .el-input__inner {
            width: 320px;
            border: 1px solid #e3e3e3;
          }
        }
        .el-cascader {
          .el-input {
            .el-input__suffix {
              right: -20px;
            }
          }
        }
      }
    }
  }
}
</style>
